module.exports = __webpack_public_path__ + "4a0ed4c488992e375e9793218146647b.woff";